<IziGrid height="100%">
    <IziCol>
      <IziButton icon="pi pi-google" label="Sign in with Google" theme="outlined" class="google" @click="signWithGoogle" />
    </IziCol>
    <IziCol>
      <IziButton icon="pi pi-facebook" label="Sign in with Faceook" theme="outlined" class="facebook" @click="signWithFacebook" />
    </IziCol>
</IziGrid>
